const runtimeEnv =
  typeof window !== 'undefined' && window.__APP_ENV__
    ? window.__APP_ENV__
    : {};

export function readAppEnv(key: keyof ImportMetaEnv): string | undefined {
  const runtimeValue = runtimeEnv[key];
  if (typeof runtimeValue === 'string' && runtimeValue.trim()) {
    return runtimeValue;
  }

  const buildValue = import.meta.env[key];
  if (typeof buildValue === 'string' && buildValue.trim()) {
    return buildValue;
  }

  return undefined;
}
